<template>
  <a-modal
    title="贸易结算表信息"
    :visible="showTubeView"
    width="80%"
    destroyOnClose
    @ok="closeTubeView"
    @cancel="closeTubeView"
    style="position: absolute; left: 18rem; z-index: 999; top: 3rem"
  >
    <a-table
      rowKey="id"
      :data-source="dataList"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD") }}</span>
      <span slot="installDate" slot-scope="text">{{ moment(text).format("YYYY-MM-DD") }}</span>
      <template slot="waterTypeAction" slot-scope="text">
        <span v-if="text==0">居民用水</span>
        <span v-if="text==1">非居民用水</span>
        <span v-if="text==2">特种用水</span>
      </template>
      <template slot="statusAction" slot-scope="text">
        <a-tag v-if="text==0" color="green">在线</a-tag>
        <a-tag v-if="text==1" color="yellow">库存</a-tag>
      </template>
      <!-- <span slot="action" slot-scope="text, record">
        <a @click="jumpFather(record)">跳转</a>
      </span>-->
    </a-table>
  </a-modal>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName',
        },
        {
          title: '分类编码',
          dataIndex: 'classNo',
        },
        {
          title: '用户编号',
          dataIndex: 'appearanceNo',
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName',
        },
        {
          title: '用户地址',
          dataIndex: 'address',
        },
        {
          title: '手机号',
          dataIndex: 'telephone',
        },
        {
          title: '安装日期',
          dataIndex: 'installDate',
          scopedSlots: {customRender: 'installDate'}
        },
        {
          title: '型号',
          dataIndex: 'model',
        },
        {
          title: '厂家',
          dataIndex: 'firm',
        },
        {
          title: '表身号',
          dataIndex: 'meterModel',
        },
        {
          title: '物探点',
          dataIndex: 'geophysicalPointNumber',
        },
        {
          title: '用水类型',
          dataIndex: 'waterType',
          scopedSlots: {customRender: 'waterTypeAction'}
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'statusAction'}
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: {customRender: 'createTime'}
        },
      ],
      queryUrl: '/pipe-network/yc_user_remote_water_meters/page',
      dataList: [],
      dataListLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      classNo: '',
      showTubeView: false
    }
  },
  methods: {
    moment,
    pageChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataList()
    },
    edit(classNo) {
      this.pagination.current = 1
      this.showTubeView = true
      if (classNo) {
        this.classNo = classNo
        this.getDataList()
        this.pagination.current = 1
      }
    },
    //跳转到对应阀门
    jumpFather(record) {
      this.closeTubeView()
      this.$emit('jumpFather', record)
    },
    //获取数据
    getDataList() {
      this.dataListLoading = true
      let params = {
        classNo: this.classNo
      }
      params.page = this.pagination.current
      params.limit = this.pagination.pageSize
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({data}) => {
          
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView() {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
